// @flow

import EditIcon from "@mui/icons-material/Edit";
import { FormControl, FormHelperText, FormLabel, TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import {
    DataGridPremium,
    GRID_AGGREGATION_ROOT_FOOTER_ROW_ID,
    GridActionsCellItem,
    GridToolbar
} from "@mui/x-data-grid-premium";
import dayjs from "dayjs";
import { ErrorMessage } from "formik";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ExportExcelFromUrl from "../../../components/mui/app/exportExcelFromUrl/exportExcelFromUrl";
import CustomAutocomplete from "../../../components/mui/form/autocomplete/autocomplete";
import { CustomPagination } from "../../../components/mui/grids/dataGridCustom/customPagination";
import DataGridWrapper from "../../../components/mui/grids/dataGridWrapper/dataGridWrapper";
import { API } from "../../../helpers/constants";
import { muiGridLocales } from "../../../helpers/mui/muiLocales";
import { access_skills, access_user } from "../../../helpers/rights";
import { getRouteUrl } from "../../../helpers/routing/getRouteUrl";
import { formControlDefaults } from "../../../helpers/theme/defaultProps";
import { useMuiGridServerSide } from "../../../hooks/muiGrid/useMuiGridServerSide";
import useUserData from "../../../hooks/user/useUserData";
import { withPermissionHOC } from "../../permission/components/permissionHOC/permissionHOC";
import { ROUTE_PAGE_PROJECT_DETAILS, ROUTE_PAGE_PROJECT_EDIT } from "../../projects/routes/routes";
import { WorkerGridContainer } from "../components/WorkerGridContainer";
import { REPORTS } from "../locales/namespaces";
import { ProjectGridContainer } from "../components/ProjectGridContainer"
import {DatePicker} from "@mui/x-date-pickers-pro";
import Button from "@mui/material/Button";
import {WorkersInProjectsGridContainer} from "../components/WorkersInProjectsGridContainer";
type Props = {

};
const initialStartDate = dayjs().startOf('month')
const initialEndDate = dayjs()
const WorkersInProjects = (props: Props) => {
    const { language, dateFormat } = useUserData()
    const { t } = useTranslation(REPORTS)
    const [selectedStartDate, setSelectedStartDate] = useState(initialStartDate)
    const [selectedEndDate, setSelectedEndDate] = useState(initialEndDate)
const [project,setProject] = useState('')
    const {
        isLoading,
        data,
        total,
        page,
        pageSize,
        filterModel,
        onPaginationModelChange,
        onSortModelChange,
        onFilterModelChange,
        dataManager,
    } = useMuiGridServerSide({
        url: "fts/reports",
        initialPageSize: 50,
        initialSortModel: [{ name: "id", direction: "descending" }],
        otherDataParams: {
            reportType: 4,
            ...(selectedStartDate && selectedStartDate?.isValid() && { StartDt: dayjs(selectedStartDate).format('YYYY-MM-DD') }), // Στείλε το φίλτρο μόνο αν υπάρχει η ημερομηνία. Αν υπάρχει στείλε το με το format της βάσης
            ...(selectedEndDate && selectedEndDate?.isValid() && { EndDt: dayjs(selectedEndDate).format('YYYY-MM-DD') }),
            Project:project
        }
    });

    // ημερομηνίες
    const handleStartDateChange = (newValue) => {
        setSelectedStartDate(newValue);
    }

    const handleEndDateChange = (newValue) => {
        setSelectedEndDate(newValue);
    }
    const handleProjectChange = (newValue)=>{
        setProject(newValue)
    }

    return (
        <Grid
            container
            spacing={2}
            sx={{ marginLeft: '0px', marginTop: '10px', alignItems: 'center' }}
        >
            <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                <DatePicker
                    slotProps={{
                        textField: {
                            size: 'small',
                            variant: 'standard'
                        }
                    }}
                    name="StartDt"
                    views={['year', 'month', 'day']}
                    inputFormat={'DD-MM-YYYY'}
                    format={dateFormat}
                    value={selectedStartDate}
                    onChange={handleStartDateChange}
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                <DatePicker
                    slotProps={{
                        textField: {
                            size: 'small',
                            variant: 'standard'
                        }
                    }}
                    name="EndDt"
                    views={['year', 'month', 'day']}
                    inputFormat={'DD-MM-YYYY'}
                    format={dateFormat}
                    value={selectedEndDate}
                    onChange={handleEndDateChange}
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 2 }} sx={{mb:2}}>
                <TextField
                    label={t('Project')}
                    variant="standard"
                    size="small"
                    value={project}
                    onChange={(event) =>handleProjectChange(event.target.value)}
                />
            </Grid>
            <Grid size={{ xs: 10, sm: 6, md: 5 }}>
                <Button
                    variant="outlined"
                    color="success"
                    onClick={() => {
                        dataManager({
                            ...(selectedStartDate && selectedStartDate?.isValid() && { StartDt: dayjs(selectedStartDate).format('YYYY-MM-DD') }),
                            ...(selectedEndDate && selectedEndDate?.isValid() && { EndDt: dayjs(selectedEndDate).format('YYYY-MM-DD') }),
                            Project:project
                        })
                    }}
                >
                    {t('Search')}
                </Button>
                <Button
                    sx={{marginLeft: 1}}
                    variant="outlined"
                    color="error"
                    onClick={() => {
                        const params = {
                            StartDt: dayjs(initialStartDate).format('YYYY-MM-DD'),
                            EndDt: dayjs(initialEndDate).format('YYYY-MM-DD')
                        }
                        const onSuccess = () => {
                            setSelectedEndDate(initialEndDate)
                            setSelectedStartDate(initialStartDate)
                        }
                        dataManager(params, onSuccess)
                    }}
                >
                    {t('Clear')}
                </Button>
            </Grid>
            <Grid size={{ xs: 2, sm: 6, md: 1 }}>
                <Box sx={{ textAlign: 'right' }}>
                    <ExportExcelFromUrl url={`${API}/en/fts/reports/export`} data={{
                        isActive: 0,
                        reportType: 4,
                        Project:project,
                        StartDt : dayjs(selectedStartDate).format('YYYY-MM-DD'),
                        EndDt : dayjs(selectedEndDate).format('YYYY-MM-DD'),
                        Filters: filterModel?.[0]?.predicates
                    }}/>
                </Box>
            </Grid>
            <Grid size={{ md: 12 }}>
                <DataGridWrapper sx={{ height: 600 }}>
                    <WorkersInProjectsGridContainer
                        data={data}
                        isLoading={isLoading}
                        page={page}
                        pageSize={pageSize}
                        onPaginationModelChange={onPaginationModelChange}
                        total={total}
                        onSortModelChange={onSortModelChange}
                        onFilterModelChange={onFilterModelChange}
                        language={language}
                        dateFormat={dateFormat}
                        selectedStartDate={selectedStartDate}
                        selectedEndDate={selectedEndDate}

                    />
                </DataGridWrapper>
            </Grid>
        </Grid>
    );
};


export default withPermissionHOC(WorkersInProjects, [access_skills])